import { Component } from 'react';

class CardPagination extends Component {
    render() {
        let { _pageScope, ...others } = this.props;
        return _pageScope.props.cardPagination.createCardPagination(others);
    }
}

export default CardPagination;